
const apiKey = import.meta.env.VITE_GOOGLE_API_KEY; // Replace with your API key

export default async function geocodeAddresses(addresses) {
    const results = [];
    for (const address of addresses) {
        const formattedAddress = encodeURIComponent(address);
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${formattedAddress}&key=${apiKey}`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (data.status === "OK") {
                const location = data.results[0].geometry.location;
                results.push({ address, location }); // Default weight is 1
            } else {
                console.error(`Geocoding failed for address: ${address}, status: ${data.status}`);
            }
        } catch (error) {
            console.error(`Error fetching geocoding data for address: ${address}`, error);
        }
    }
    return results;
}
